<div class="sm">
  <div class="sm__title">{{ "campaign.widget.sidebar.form-settings.show-message-on-submit" | translate }}</div>

  @if (hasOutcomes) {
    <div class="sm-card sm-card--row">
      <mat-icon class="sm-card__icon">checklist</mat-icon>
      <div class="sm-card__body">
        <div class="sm-card__name">{{ "campaign.outcomes.go-to-outcomes" | translate }}</div>
      </div>
      <button mat-stroked-button class="secondary-button sm-btn" (click)="showOutcomes()">
        <mat-icon>edit</mat-icon>
        {{ "campaign.outcomes.title" | translate }}
      </button>
    </div>
  } @else if (shouldShowRealtime) {
    <div class="sm-card sm-handlers">
      @for (key of handlerKeys; track key) {
        <div class="sm-handler">
          <div class="sm-handler__title">{{ "campaign.widget.sidebar.form-settings." + key | translate }}</div>
          <mat-radio-group class="sm-handler__group" [(ngModel)]="realTimeHandler[key].action" (ngModelChange)="onHandlerChange(key)">
            <div class="sm-handler__option">
              <mat-radio-button [value]="HandlerRealTimeProp.Message">
                {{ ("generic.show" | translate) + " " + ("generic.text" | translate | lowercase) }}
              </mat-radio-button>
              @if (realTimeHandler[key].action === HandlerRealTimeProp.Message) {
                <div class="sm-handler__message">
                  <mat-form-field class="sm-field" appearance="outline" subscriptSizing="dynamic">
                    <input matInput [(ngModel)]="realTimeHandler[key].message" [placeholder]="'generic.typeSomething' | translate" />
                  </mat-form-field>
                  <button
                    mat-icon-button
                    class="sm-handler__preview"
                    [matTooltip]="(previewingKey === key ? 'generic.hide' : 'generic.preview') | translate"
                    (click)="togglePreview(key)">
                    <mat-icon>{{ previewingKey === key ? "visibility_off" : "visibility" }}</mat-icon>
                  </button>
                </div>
              }
            </div>

            <div class="sm-handler__option">
              <mat-radio-button
                [value]="HandlerRealTimeProp.StepId"
                [disabled]="!choosableStates.length"
                [matTooltip]="!choosableStates.length ? ('campaign.widget.sidebar.form-settings.at-least-3-states' | translate) : null">
                {{ "campaign.widget.sidebar.edit.button-action.change-state" | translate }}
              </mat-radio-button>
              @if (realTimeHandler[key].action === HandlerRealTimeProp.StepId) {
                <mat-form-field class="sm-field" appearance="outline" subscriptSizing="dynamic">
                  <mat-select
                    [(ngModel)]="realTimeHandler[key].stepId"
                    [placeholder]="('generic.select' | translate) + ' ' + ('generic.step' | translate | lowercase)">
                    @for (state of choosableStates; track state.id) {
                      <mat-option [value]="state.id">{{ state.titleState }}</mat-option>
                    }
                  </mat-select>
                  @if (!realTimeHandler[key].stepId || realTimeHandler[key].isStepInvalid) {
                    <mat-hint class="sm-error">
                      {{ "campaign.widget.sidebar.form-settings.choose-step" | translate }}
                    </mat-hint>
                  }
                </mat-form-field>
              }
            </div>

            @if (key === FormSettingsHandlerTypes.Success) {
              <div class="sm-handler__option">
                <mat-radio-button [value]="HandlerRealTimeProp.Close">
                  {{ "campaign.widget.sidebar.edit.button-action.close-widget" | translate }}
                </mat-radio-button>
              </div>
            }
          </mat-radio-group>
        </div>
      }

      <ng-container [ngTemplateOutlet]="subscriberCheck"></ng-container>

      <div class="sm-actions">
        <button mat-stroked-button class="primary-button" [disabled]="realTimeHandlerSaveDisabled" (click)="saveRealTimeHandlerData()">
          {{ "generic.save" | translate | uppercase }}
        </button>
      </div>
    </div>
  } @else {
    <div class="sm-card">
      <div class="sm-switch">
        <mat-slide-toggle
          class="sm-toggle"
          [(ngModel)]="automationSwitchStateIsOn"
          [disabled]="automationSwitchStateDisabled"
          [matTooltip]="'campaign.widget.sidebar.form-settings.only-one-state' | translate"
          [matTooltipDisabled]="!automationSwitchStateDisabled"
          (change)="toggleSwitchStateIsOn()">
          {{ "campaign.widget.sidebar.form-settings.switch-state" | translate }}
        </mat-slide-toggle>

        @if (choosableStates.length) {
          <mat-form-field class="sm-field" appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "campaign.widget.state.label" | translate }}</mat-label>
            <mat-select [(ngModel)]="automationSwitchStateTo" [disabled]="!automationSwitchStateIsOn" (selectionChange)="updateStateToSwitchTo()">
              @for (state of choosableStates; track state.id) {
                <mat-option [value]="state.id">{{ state.titleState }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else {
          <div class="sm-hint">{{ "campaign.widget.sidebar.form-settings.no-other-states" | translate }}</div>
        }
      </div>

      @if (automationSwitchStateIsOn && alternativeApps.length) {
        <div class="sm-alt" @expandReveal>
          <mat-slide-toggle
            class="sm-toggle"
            [(ngModel)]="listCheckIsOn"
            [disabled]="listCheckIsDisabled"
            [matTooltip]="listCheckDisabledMessage ? (listCheckDisabledMessage | translate) : null"
            [matTooltipDisabled]="!listCheckIsDisabled"
            (change)="toggleSwitchStateCheck()">
            {{ "campaign.widget.sidebar.form-settings.alternating-message" | translate }}
          </mat-slide-toggle>

          @if (listCheckIsOn) {
            @if (listCheckAvailableStates.length || choosableStates.length >= 2) {
              <div class="sm-alt__fields" @expandReveal>
                <mat-form-field class="sm-field" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>{{ "campaign.widget.sidebar.form-settings.app" | translate }}</mat-label>
                  <mat-select [(ngModel)]="automationAlternateSwitchApp" (selectionChange)="updateAlternateAppToSwitchTo()">
                    @for (app of alternativeApps; track app) {
                      <mat-option [value]="app">{{ app }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                @if (automationAlternateSwitchApp && listCheckAvailableLists.length) {
                  <mat-form-field class="sm-field" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ "campaign.widget.sidebar.form-settings.list" | translate }}</mat-label>
                    <mat-select [(ngModel)]="automationAlternateSwitchListId" [disabled]="listCheckLoadingLists" (selectionChange)="updateAlternateSelection()">
                      @for (item of listCheckAvailableLists; track item.id) {
                        <mat-option [value]="item.id">{{ item.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }

                <mat-form-field class="sm-field" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>{{ "campaign.widget.sidebar.form-settings.state" | translate }}</mat-label>
                  <mat-select [(ngModel)]="automationAlternateSwitchStateId" (selectionChange)="updateAlternateSelection()">
                    @for (state of listCheckAvailableStates; track state.id) {
                      <mat-option [value]="state.id">{{ state.titleState }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <div class="sm-actions">
                  <button
                    mat-stroked-button
                    class="primary-button"
                    [disabled]="listCheckSaveButtonDisabled || listCheckIsDisabled"
                    (click)="saveAlternateSwitchStateData()">
                    {{ "generic.save" | translate | uppercase }}
                  </button>
                </div>

                <ng-container [ngTemplateOutlet]="subscriberCheck" [ngTemplateOutletContext]="{ requireSave: listCheckSaveButtonDisabled }"></ng-container>
              </div>
            } @else {
              <div class="sm-hint">{{ "campaign.widget.sidebar.form-settings.at-least-3-states" | translate }}</div>
            }
          }
        </div>
      }
    </div>
  }
</div>

<ng-template #subscriberCheck let-requireSave="requireSave">
  @if (allowVerify) {
    <div class="sm-subscriber">
      <div class="sm-card__label">{{ "campaign.widget.sidebar.form-settings.subscriber-check" | translate }}</div>
      @if (newSubscriberBlockedByUpdate) {
        <div class="sm-hint">{{ "campaign.widget.sidebar.form-settings.subscriber-check-update-contact" | translate }}</div>
      } @else if (newSubscriberCheckDisabled) {
        <div
          class="sm-hint"
          [innerHTML]="'campaign.widget.sidebar.form-settings.subscriber-check-link' | translate: { link: '/automations/edit/' + automationId }"></div>
      } @else if (requireSave) {
        <div class="sm-hint" [innerHTML]="'campaign.widget.sidebar.form-settings.subscriber-check-required' | translate"></div>
      } @else {
        <mat-slide-toggle class="sm-toggle" [checked]="runAutomationOnlyIfNewSubscriber === true" (click)="toggleSubscriberCheckSetting()">
          {{ "campaign.widget.sidebar.form-settings.subscriber-check-toggle" | translate }}
        </mat-slide-toggle>
      }
    </div>
  }
</ng-template>
